/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressDraft } from './AddressDraft';
import {
    AddressDraftFromJSON,
    AddressDraftFromJSONTyped,
    AddressDraftToJSON,
    AddressDraftToJSONTyped,
} from './AddressDraft';
import type { ContactDraft } from './ContactDraft';
import {
    ContactDraftFromJSON,
    ContactDraftFromJSONTyped,
    ContactDraftToJSON,
    ContactDraftToJSONTyped,
} from './ContactDraft';

/**
 * Broker information. Required if cross border.
 * @export
 * @interface BrokerDraft
 */
export interface BrokerDraft {
    /**
     * 
     * @type {string}
     * @memberof BrokerDraft
     */
    businessName?: string;
    /**
     * 
     * @type {AddressDraft}
     * @memberof BrokerDraft
     */
    address?: AddressDraft;
    /**
     * 
     * @type {ContactDraft}
     * @memberof BrokerDraft
     */
    contact?: ContactDraft;
    /**
     * Broker account number
     * @type {string}
     * @memberof BrokerDraft
     */
    accountNumber?: string;
}

/**
 * Check if a given object implements the BrokerDraft interface.
 */
export function instanceOfBrokerDraft(value: object): value is BrokerDraft {
    return true;
}

export function BrokerDraftFromJSON(json: any): BrokerDraft {
    return BrokerDraftFromJSONTyped(json, false);
}

export function BrokerDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'businessName': json['businessName'] == null ? undefined : json['businessName'],
        'address': json['address'] == null ? undefined : AddressDraftFromJSON(json['address']),
        'contact': json['contact'] == null ? undefined : ContactDraftFromJSON(json['contact']),
        'accountNumber': json['accountNumber'] == null ? undefined : json['accountNumber'],
    };
}

  export function BrokerDraftToJSON(json: any): BrokerDraft {
      return BrokerDraftToJSONTyped(json, false);
  }

  export function BrokerDraftToJSONTyped(value?: BrokerDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'businessName': value['businessName'],
        'address': AddressDraftToJSON(value['address']),
        'contact': ContactDraftToJSON(value['contact']),
        'accountNumber': value['accountNumber'],
    };
}

